import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default__default from 'react';
import PropTypes__default from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/dist/scss/components/notification.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import { requiredChildrenValidation } from '../../prop-types-validators/children-validator.js';
import { NOTIF_CONTAINER_POSITIONS } from './types.js';
import { Injecss } from '../../packages/injecss/injecss.js';

var bem = HoneyBem.init('notification-container', styles);
var NotificationContainer = function (_a) {
  var position = _a.position,
    extraClasses = _a.extraClasses,
    children = _a.children,
    rest = __rest(_a, ["position", "extraClasses", "children"]);
  return /*#__PURE__*/React__default__default.createElement("div", __assign({
    className: bem.b([position], extraClasses)
  }, rest), children);
};
NotificationContainer.displayName = 'NotificationContainer';
NotificationContainer.defaultProps = {
  position: 'top-right',
  extraClasses: ''
};
NotificationContainer.propTypes = {
  position: PropTypes__default.oneOf(NOTIF_CONTAINER_POSITIONS),
  extraClasses: PropTypes__default.string,
  // eslint-disable-next-line react/require-default-props
  children: requiredChildrenValidation('Notification')
};
var notificationContainer = Injecss(NotificationContainer, styles);

export { NotificationContainer, notificationContainer as default };
